<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3
{
  max-width: 100%;
    height: 0;
    width: 100% !important;
    height: 33vh !important;
    /* background: red; */
    margin-bottom: 1vh !important;

}
// .vjs-custom-skin > .video-js .vjs-control {
//     width: 3em;
//     position: absolute;
//     right: 0;
// }
// .video-js .vjs-volume-panel {
//     display: flex;
//     display: none;
// }
// .video-js .vjs-mute-control {
//     cursor: pointer;
//     flex: none;
//     padding-left: 2em;
//     padding-right: 2em;
//     padding-bottom: 3em;
//     display: none;
// }
.video-js .vjs-control-bar {
    display: none;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3em;
    /* background-color: #2B333F; */
    background-color: rgb(43 51 63 / 0%) !important;
}
	//全屏按钮
  video::-webkit-media-controls-fullscreen-button {
        display: none;
    }
    //播放按钮
    video::-webkit-media-controls-play-button {
        display: none;
    }
    //进度条
    video::-webkit-media-controls-timeline {
        display: none;
    }
    //观看的当前时间
    video::-webkit-media-controls-current-time-display{
        display: none;            
    }
    //剩余时间
    video::-webkit-media-controls-time-remaining-display {
        display: none;            
    }
    //音量按钮
    video::-webkit-media-controls-mute-button {
        display: none;            
    }
    video::-webkit-media-controls-toggle-closed-captions-button {
        display: none;            
    }
    //音量的控制条
    video::-webkit-media-controls-volume-slider {
        display: none;            
    }
    //所有控件
    video::-webkit-media-controls-enclosure{ 
        display: none;
    }

</style>
